import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <main className="py-20">
        {/* Hero Section */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              About DP Crypt
            </h1>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Your trusted partner for instant cryptocurrency transactions. Fast, secure, and reliable USDT purchases worldwide.
            </p>
          </div>
        </section>

        {/* Company Information */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
          <div className="bg-gray-800 rounded-2xl p-8 md:p-12 border border-gray-700">
            <h2 className="text-3xl font-bold text-white mb-8">Company Information</h2>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                Dream Pulse Limited LTD is a limited company registered at Comoros Union, with Limited company number <strong className="text-white">HY01023047</strong> and having its registered office at Bonovo Road, Fomboni, Island of Mohéli, Comoros Union.
              </p>
              <p>
                <strong className="text-white">INTERNATIONAL BROKERAGE and CLEARING HOUSE LICENSE:</strong> T2023392
              </p>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
          <h2 className="text-3xl font-bold text-white mb-12 text-center">Contact Information</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Registered Address */}
            <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">Registered Address</h3>
                  <p className="text-gray-400">
                    Bonovo Road, Fomboni<br />
                    Island of Mohéli<br />
                    Comoros Union
                  </p>
                </div>
              </div>
            </div>

            {/* Physical Address */}
            <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">Physical Address</h3>
                  <p className="text-gray-400">
                    BLK 18 Lot 2 Sampaguita Corner St.<br />
                    Brgy San Juan<br />
                    Taytay, Rizal, Philippines
                  </p>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">Email</h3>
                  <a href="/contact" className="text-teal-500 hover:text-teal-400 transition-colors">
                    contact us
                  </a>
                </div>
              </div>
            </div>

            {/* Telephone */}
            <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">Telephone</h3>
                  <a href="tel:+6323769134" className="text-teal-500 hover:text-teal-400 transition-colors">
                    +63 2 8376 9134
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
          <div className="bg-gradient-to-br from-teal-500/10 to-blue-500/10 rounded-2xl p-8 md:p-12 border border-teal-500/20">
            <h2 className="text-3xl font-bold text-white mb-6">Our Mission</h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              At DP Crypt, we are committed to providing fast, secure, and reliable cryptocurrency trading services to customers worldwide. Our platform enables instant USDT purchases with multiple payment methods, ensuring a seamless experience for both beginners and experienced traders.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              We prioritize security, transparency, and customer satisfaction in every transaction, making cryptocurrency accessible to everyone.
            </p>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-white mb-12 text-center">Why Choose DP Crypt</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700 text-center">
              <div className="w-16 h-16 bg-teal-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-3xl text-teal-500"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">Secure & Trusted</h3>
              <p className="text-gray-400">
                Licensed and regulated with advanced security measures to protect your transactions and personal information.
              </p>
            </div>

            <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700 text-center">
              <div className="w-16 h-16 bg-teal-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-flashlight-line text-3xl text-teal-500"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">Instant Transactions</h3>
              <p className="text-gray-400">
                Complete your USDT purchases in minutes with our streamlined process and instant delivery system.
              </p>
            </div>

            <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700 text-center">
              <div className="w-16 h-16 bg-teal-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-customer-service-2-line text-3xl text-teal-500"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">24/7 Support</h3>
              <p className="text-gray-400">
                Our dedicated support team is available around the clock to assist you with any questions or concerns.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
